import React from "react";
import BulkUpload from "../../../../components/BulkUpload/BulkUpload";

const baselineColumns = [
  "GRADE_CODE",
  "DOMAIN_NAME",
  "LO_CODE",
  "LO_DESCRIPTION_AR",
  "BASELINE_NAME_AR",
  "BASELINE_ASSESSMENT_CONTENT_ID",
  "QUESTION_CONTENT_ID"
];

function BaselineUpload({}) {
  return (
    <BulkUpload
      fileColumns={baselineColumns}
      sheetName="BaselineAssessmentData"
    />
  );
}

export default BaselineUpload;
